<template>
  <Print470
    v-if="isPrintMode"
    :form="value"
    :board="board"
    :chart-data="chartData"
  />
  <div v-else>
    <!-- search -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
        <component
          v-for="(component, index) in stdSearchComponents"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <div class="flex items-center justify-between mb-4">
      <span style="font-size: 18px; font-weight: 500">{{ `환경사업소 | 응답인원 : ${list.length}명` }}</span>
      <vs-button color="secondary" type="border" @click="onClickPrint">인쇄</vs-button>
    </div>

    <div class="mt-4 grid gap-4 card-grid">
      <!--      성별-->
      <vs-card class="w-full">
        <div class="p-2">
          <h5 class="mb-4"><i class="dot"></i>성별</h5>
          <table>
            <colgroup>
              <col width="80px" />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 성별데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 성별인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-card>

      <!--      결혼여부-->
      <vs-card class="w-full">
        <div class="p-2">
          <h5 class="mb-4"><i class="dot"></i>결혼여부</h5>
          <table>
            <colgroup>
              <col width="80px" />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 결혼데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 결혼인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-card>

      <!--      기본정보(평균)-->
      <vs-card class="w-full">
        <div class="p-2">
          <h5 class="mb-4"><i class="dot"></i>기본정보(평균)</h5>
          <table>
            <thead>
              <tr>
                <th>구분</th>
                <th>인원</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 기본정보데이터" :key="index">
                <td>{{ item.구분 }}</td>
                <td>{{ item.평균 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-card>
    </div>

    <vs-card class="w-full">
      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>1. 여가 및 취미활동</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 여가및취미활동데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 여가및취미활동인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="여가및취미활동데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>
    </vs-card>

    <vs-card class="w-full">
      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>2. 하루 평균 가사 노동시간</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 하루평균가사노동시간데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 하루평균가사노동시간인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="하루평균가사노동시간데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>
    </vs-card>

    <vs-card class="w-full">
      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>3. 질병 진단 여부</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 질병진단여부데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 질병진단여부인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="질병진단여부데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>3.1 현재 상태</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 질병_현재상태데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 질병_현재상태인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="질병_현재상태데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>3.2 질병명</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 질병_질병명데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 질병_질병명인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="질병_질병명데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>
    </vs-card>

    <vs-card class="w-full">
      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>4. 사고 여부</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 사고여부데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 사고여부인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="사고여부데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>4.1 사고 부위</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 사고_부위데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 사고_부위인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="사고_부위데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>
    </vs-card>

    <vs-card class="w-full">
      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>5. 육체적 부담 정도</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 육체적부담정도데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 육체적부담정도인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="육체적부담정도데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>
    </vs-card>

    <vs-card class="w-full">
      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>6. 근골증상여부</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th>인원</th>
                <th>점유율</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 근골증상여부데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td>{{ item.인원 }}</td>
                <td>{{ item.점유율 }}%</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th>{{ 근골증상여부인원 }}</th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <BasicPieChart :value="근골증상여부데이터" labelField="구분" valueField="점유율" :height="150" :show-data-labels="false" :legend-width="330"></BasicPieChart>
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>6.2 통증 지속 기간</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="200px" />
              <col v-for="(_, index) in getChartResultType('근골증상_통증지속시간')" :key="index" />
              <col width="100px" />
              <!-- 합계 열 -->
            </colgroup>
            <thead>
              <tr>
                <th>순번</th>
                <th>구분</th>
                <th v-for="(item, index) in getChartResultType('근골증상_통증지속시간')" :key="index">
                  {{ item }}
                </th>
                <th>합계</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in 근골증상_통증지속시간데이터" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.구분 }}</td>
                <td v-for="(duration, dIndex) in getChartResultType('근골증상_통증지속시간')" :key="dIndex">
                  {{ item[duration] }}
                </td>
                <td>{{ item.합계 }}</td>
              </tr>
              <tr>
                <th colspan="2">합계</th>
                <th v-for="(duration, dIndex) in getChartResultType('근골증상_통증지속시간')" :key="dIndex">
                  {{ 근골증상_통증지속시간데이터.reduce((sum, item) => sum + item[duration], 0) }}
                </th>
                <th>{{ 근골증상_통증지속시간데이터.reduce((sum, item) => sum + item.합계, 0) }}</th>
              </tr>
              <tr>
                <th colspan="2">비율</th>
                <th v-for="(duration, dIndex) in getChartResultType('근골증상_통증지속시간')" :key="dIndex">
                  {{ ((근골증상_통증지속시간데이터.reduce((sum, item) => sum + item[duration], 0) / 근골증상_통증지속시간데이터.reduce((total, item) => total + item.합계, 0)) * 100).toFixed(2) }}%
                </th>
                <th>100%</th>
              </tr>
            </tbody>
          </table>

          <symptom-bar-chart :series="통증지속시간차트데이터.series" :categories="통증지속시간차트데이터.categories" :height="330" />
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>6.3 통증 정도</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="200px" />
              <col v-for="(_, index) in getChartResultType('근골증상_통증정도')" :key="index" />
              <col width="100px" />
              <!-- 합계 열 -->
            </colgroup>
            <thead>
            <tr>
              <th>순번</th>
              <th>구분</th>
              <th v-for="(item, index) in getChartResultType('근골증상_통증정도')" :key="index">
                {{ item }}
              </th>
              <th>합계</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in 근골증상_통증정도데이터" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.구분 }}</td>
              <td v-for="(duration, dIndex) in getChartResultType('근골증상_통증정도')" :key="dIndex">
                {{ item[duration] }}
              </td>
              <td>{{ item.합계 }}</td>
            </tr>
            <tr>
              <th colspan="2">합계</th>
              <th v-for="(duration, dIndex) in getChartResultType('근골증상_통증정도')" :key="dIndex">
                {{ 근골증상_통증정도데이터.reduce((sum, item) => sum + item[duration], 0) }}
              </th>
              <th>{{ 근골증상_통증정도데이터.reduce((sum, item) => sum + item.합계, 0) }}</th>
            </tr>
            <tr>
              <th colspan="2">비율</th>
              <th v-for="(duration, dIndex) in getChartResultType('근골증상_통증정도')" :key="dIndex">
                {{ ((근골증상_통증정도데이터.reduce((sum, item) => sum + item[duration], 0) / 근골증상_통증정도데이터.reduce((total, item) => total + item.합계, 0)) * 100).toFixed(2) }}%
              </th>
              <th>100%</th>
            </tr>
            </tbody>
          </table>

          <symptom-bar-chart :series="통증정도차트데이터.series" :categories="통증정도차트데이터.categories" :height="330" />
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>6.4 통증 빈도</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="200px" />
              <col v-for="(_, index) in getChartResultType('근골증상_통증빈도')" :key="index" />
              <col width="100px" />
              <!-- 합계 열 -->
            </colgroup>
            <thead>
            <tr>
              <th>순번</th>
              <th>구분</th>
              <th v-for="(item, index) in getChartResultType('근골증상_통증빈도')" :key="index">
                {{ item }}
              </th>
              <th>합계</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in 근골증상_통증빈도데이터" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.구분 }}</td>
              <td v-for="(duration, dIndex) in getChartResultType('근골증상_통증빈도')" :key="dIndex">
                {{ item[duration] }}
              </td>
              <td>{{ item.합계 }}</td>
            </tr>
            <tr>
              <th colspan="2">합계</th>
              <th v-for="(duration, dIndex) in getChartResultType('근골증상_통증빈도')" :key="dIndex">
                {{ 근골증상_통증빈도데이터.reduce((sum, item) => sum + item[duration], 0) }}
              </th>
              <th>{{ 근골증상_통증빈도데이터.reduce((sum, item) => sum + item.합계, 0) }}</th>
            </tr>
            <tr>
              <th colspan="2">비율</th>
              <th v-for="(duration, dIndex) in getChartResultType('근골증상_통증빈도')" :key="dIndex">
                {{ ((근골증상_통증빈도데이터.reduce((sum, item) => sum + item[duration], 0) / 근골증상_통증빈도데이터.reduce((total, item) => total + item.합계, 0)) * 100).toFixed(2) }}%
              </th>
              <th>100%</th>
            </tr>
            </tbody>
          </table>

          <symptom-bar-chart :series="통증빈도차트데이터.series" :categories="통증빈도차트데이터.categories" :height="330" />
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>6.5 지난 1주일 증상 여부</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="200px" />
              <col v-for="(_, index) in getChartResultType('근골증상_지난1주일증상여부')" :key="index" />
              <col width="100px" />
              <!-- 합계 열 -->
            </colgroup>
            <thead>
            <tr>
              <th>순번</th>
              <th>구분</th>
              <th v-for="(item, index) in getChartResultType('근골증상_지난1주일증상여부')" :key="index">
                {{ item }}
              </th>
              <th>합계</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in 근골증상_지난1주일증상여부데이터" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.구분 }}</td>
              <td v-for="(duration, dIndex) in getChartResultType('근골증상_지난1주일증상여부')" :key="dIndex">
                {{ item[duration] }}
              </td>
              <td>{{ item.합계 }}</td>
            </tr>
            <tr>
              <th colspan="2">합계</th>
              <th v-for="(duration, dIndex) in getChartResultType('근골증상_지난1주일증상여부')" :key="dIndex">
                {{ 근골증상_지난1주일증상여부데이터.reduce((sum, item) => sum + item[duration], 0) }}
              </th>
              <th>{{ 근골증상_지난1주일증상여부데이터.reduce((sum, item) => sum + item.합계, 0) }}</th>
            </tr>
            <tr>
              <th colspan="2">비율</th>
              <th v-for="(duration, dIndex) in getChartResultType('근골증상_지난1주일증상여부')" :key="dIndex">
                {{ ((근골증상_지난1주일증상여부데이터.reduce((sum, item) => sum + item[duration], 0) / 근골증상_지난1주일증상여부데이터.reduce((total, item) => total + item.합계, 0)) * 100).toFixed(2) }}%
              </th>
              <th>100%</th>
            </tr>
            </tbody>
          </table>

          <symptom-bar-chart :series="지난1주일증상여부차트데이터.series" :categories="지난1주일증상여부차트데이터.categories" :height="330" />
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>6.6 통증으로 인해 일어난 일</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="200px" />
              <col v-for="(_, index) in getChartResultType('근골증상_통증으로인해일어난일')" :key="index" />
              <col width="100px" />
              <!-- 합계 열 -->
            </colgroup>
            <thead>
            <tr>
              <th>순번</th>
              <th>구분</th>
              <th v-for="(item, index) in getChartResultType('근골증상_통증으로인해일어난일')" :key="index">
                {{ item }}
              </th>
              <th>합계</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in 근골증상_통증으로인해일어난일데이터" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.구분 }}</td>
              <td v-for="(duration, dIndex) in getChartResultType('근골증상_통증으로인해일어난일')" :key="dIndex">
                {{ item[duration] }}
              </td>
              <td>{{ item.합계 }}</td>
            </tr>
            <tr>
              <th colspan="2">합계</th>
              <th v-for="(duration, dIndex) in getChartResultType('근골증상_통증으로인해일어난일')" :key="dIndex">
                {{ 근골증상_통증으로인해일어난일데이터.reduce((sum, item) => sum + item[duration], 0) }}
              </th>
              <th>{{ 근골증상_통증으로인해일어난일데이터.reduce((sum, item) => sum + item.합계, 0) }}</th>
            </tr>
            <tr>
              <th colspan="2">비율</th>
              <th v-for="(duration, dIndex) in getChartResultType('근골증상_통증으로인해일어난일')" :key="dIndex">
                {{ ((근골증상_통증으로인해일어난일데이터.reduce((sum, item) => sum + item[duration], 0) / 근골증상_통증으로인해일어난일데이터.reduce((total, item) => total + item.합계, 0)) * 100).toFixed(2) }}%
              </th>
              <th>100%</th>
            </tr>
            </tbody>
          </table>

          <symptom-bar-chart :series="통증으로인해일어난일차트데이터.series"
                             :categories="통증으로인해일어난일차트데이터.categories"
                             :height="330"
                             :colors="['#0058FF', '#21D59B', '#FFC700', '#F99600', '#9CA0A4']"
          />
        </div>
      </div>

      <div class="p-2">
        <h5 class="mb-4"><i class="dot"></i>6.7 근골격계질환자 추정</h5>
        <div class="mt-2 grid gap-4 items-center responsive-grid">
          <table>
            <colgroup>
              <col width="80px" />
              <col width="66%" />
              <col width="17%" />
              <col width="17%" />
            </colgroup>
            <thead>
            <tr>
              <th>순번</th>
              <th>구분</th>
              <th>인원</th>
              <th>점유율</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in 근골증상_근골격계질환자추정데이터" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.구분 }}</td>
              <td>{{ item.인원 }}</td>
              <td>{{ item.점유율 }}%</td>
            </tr>
            <tr>
              <th colspan="2">합계</th>
              <th>{{ 근골증상_근골격계질환자추정인원 }}</th>
              <th>100%</th>
            </tr>
            </tbody>
          </table>

          <BasicPieChart :value="근골증상_근골격계질환자추정데이터" labelField="구분" valueField="점유율"
                         :height="150" :show-data-labels="false" :legend-width="330"
                         :colors="['#0058FF', '#FFC700', '#F0142F']"
          />
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import List from "./List.js";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import BasicPieChart from "@/components/BasicPieChart.vue";
import SymptomBarChart from "@/components/SymptomBarChart.vue";
import Print470 from "@/views/boards/single-page/470/Print.vue";

export default {
  components: {
    Print470,
    SymptomBarChart,
    BasicPieChart,
    KPagination,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
    mode: {
      type: String,
      default: "list",
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return 470;
    },
    stdSearchComponents() {
      const stdSearchComponents = [
        {
          component: "search-year",
          label: "대상년도",
          value: "year",
          query: { y: "year" },
          options: {
            default: new Date().getFullYear(),
          },
        },
        {
          component: "search-select-company-name",
          label: "부서명",
          value: "company_name",
        },
        {
          // 부서명 오른쪽에 표시되는 팀명 선택 (선택된 부서의 하위 팀만 표시, "전체" 가능)
          component: "search-select-team-name",
          label: "팀명",
          value: "team_name",
          query: { tName: "team_name" },
          options: {
            department: this.nav.value.company_name,
          },
        },
        // {
        //   component: "search-keyword",
        //   label: "수급업체명",
        //   value: "수급업체명",
        //   query: { k: "수급업체명" },
        //   options: {
        //     default: "",
        //   },
        // },
      ];

      for (const component of stdSearchComponents) {
        component.component = searchComponent[component["component"]];
      }

      return stdSearchComponents;
    },
    통증지속시간차트데이터() {
      return this.prepareSymptomPainDurationChart("근골증상_통증지속시간");
    },
    통증정도차트데이터() {
      return this.prepareSymptomPainDurationChart("근골증상_통증정도");
    },
    통증빈도차트데이터() {
      return this.prepareSymptomPainDurationChart("근골증상_통증빈도");
    },
    지난1주일증상여부차트데이터() {
      return this.prepareSymptomPainDurationChart("근골증상_지난1주일증상여부");
    },
    통증으로인해일어난일차트데이터() {
      return this.prepareSymptomPainDurationChart("근골증상_통증으로인해일어난일");
    },

  },
  data() {
    return {
      isPrintMode: false,
      chartData: {},
      nav: {
        value: {
          year: new Date().getFullYear(),
          company_name: "",
          team_name: "",
        },
      },

      page: 1,
      lastPage: 1,
      perPage: 20,
      total: 0,
      list: [], // total
      성별데이터: [],
      성별인원: 0,
      결혼데이터: [],
      결혼인원: 0,
      기본정보데이터: [],
      // 1
      여가및취미활동데이터: [],
      여가및취미활동인원: 0,
      // 2
      하루평균가사노동시간데이터: [],
      하루평균가사노동시간인원: 0,
      // 3
      질병진단여부데이터: [],
      질병진단여부인원: 0,
      질병_현재상태데이터: [],
      질병_현재상태인원: 0,
      질병_질병명데이터: [],
      질병_질병명인원: 0,
      // 4
      사고여부데이터: [],
      사고여부인원: 0,
      사고_부위데이터: [],
      사고_부위인원: 0,
      // 5
      육체적부담정도데이터: [],
      육체적부담정도인원: 0,
      // 6
      근골증상여부데이터: [],
      근골증상여부인원: 0,
      근골증상_통증지속시간데이터: [],
      근골증상_통증정도데이터: [],
      근골증상_통증빈도데이터: [],
      근골증상_지난1주일증상여부데이터: [],
      근골증상_통증으로인해일어난일데이터: [],
      근골증상_근골격계질환자추정데이터: [],
      근골증상_근골격계질환자추정인원: 0,
    };
  },
  watch: {
    page: {
      immediate: true,
      deep: true,
      handler(value) {
        this.loadListBoard();
      },
    },
  },
  mounted() {
    this.loadListBoard();
  },
  methods: {
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    onClickSearch() {
      this.page = 1;
      this.loadListBoard();
    },
    onClickPrint() {
      this.chartData = {
        성별데이터: this.성별데이터,
        성별인원: this.성별인원,
        결혼데이터: this.결혼데이터,
        결혼인원: this.결혼인원,
        기본정보데이터: this.기본정보데이터,
        여가및취미활동데이터: this.여가및취미활동데이터,
        여가및취미활동인원: this.여가및취미활동인원,
        하루평균가사노동시간데이터: this.하루평균가사노동시간데이터,
        하루평균가사노동시간인원: this.하루평균가사노동시간인원,
        질병진단여부데이터: this.질병진단여부데이터,
        질병진단여부인원: this.질병진단여부인원,
        질병_현재상태데이터: this.질병_현재상태데이터,
        질병_현재상태인원: this.질병_현재상태인원,
        질병_질병명데이터: this.질병_질병명데이터,
        질병_질병명인원: this.질병_질병명인원,
        사고여부데이터: this.사고여부데이터,
        사고여부인원: this.사고여부인원,
        사고_부위데이터: this.사고_부위데이터,
        사고_부위인원: this.사고_부위인원,
        육체적부담정도데이터: this.육체적부담정도데이터,
        육체적부담정도인원: this.육체적부담정도인원,
        근골증상여부데이터: this.근골증상여부데이터,
        근골증상여부인원: this.근골증상여부인원,
        근골증상_통증지속시간데이터: this.근골증상_통증지속시간데이터,
        근골증상_통증정도데이터: this.근골증상_통증정도데이터,
        근골증상_통증빈도데이터: this.근골증상_통증빈도데이터,
        근골증상_지난1주일증상여부데이터: this.근골증상_지난1주일증상여부데이터,
        근골증상_통증으로인해일어난일데이터: this.근골증상_통증으로인해일어난일데이터,
        근골증상_근골격계질환자추정데이터: this.근골증상_근골격계질환자추정데이터,
        근골증상_근골격계질환자추정인원: this.근골증상_근골격계질환자추정인원,

        통증지속시간차트데이터: this.prepareSymptomPainDurationChart("근골증상_통증지속시간"),
        통증정도차트데이터: this.prepareSymptomPainDurationChart("근골증상_통증정도"),
        통증빈도차트데이터: this.prepareSymptomPainDurationChart("근골증상_통증빈도"),
        지난1주일증상여부차트데이터: this.prepareSymptomPainDurationChart("근골증상_지난1주일증상여부"),
        통증으로인해일어난일차트데이터: this.prepareSymptomPainDurationChart("근골증상_통증으로인해일어난일"),
      };

      // 프린트 모드 활성화
      this.isPrintMode = true;

      // Vue 렌더링 사이클 완료 후 인쇄 실행
      this.$nextTick(() => {
        setTimeout(() => {
          // viewer.vue와 유사한 방식으로 구현
          const g_oBeforeBody = document.querySelector(".print-container").innerHTML;

          // 인쇄 스타일 생성
          const style = document.createElement("style");
          style.type = "text/css";
          style.media = "print";

          // 인쇄 스타일 설정 (A4 가로 방향으로 설정)
          style.innerHTML = `
        @media print {
          @page {
            size: a4 portrait;
            margin: 10mm;
          }
          body {
            margin: 0;
            padding: 0;
            background: #fff;
          }
          .print-container {
            width: 100%;
            max-width: 100%;
          }
        }
      `;

          document.head.appendChild(style);

          window.onbeforeprint = function() {
            document.body.style.backgroundColor = "#fff";
            document.body.innerHTML = `${g_oBeforeBody}`;
          };

          // 인쇄 실행
          window.print();

          // 페이지 리로드하여 원상태로 복귀
          location.reload();
        }, 3000);
      });
    },

    getConditions(nav) {
      const conditions = [];
      const search = nav.value;

      //  검색일
      if (search.year) {
        conditions.push({key: 'header.year', operator: '=', value: search.year})
      }
      // 검색부서명
      if (search.company_name) {
        conditions.push({key: 'body.stdInfo.부서명_과', operator: '=', value: search.company_name})
      }
      // 검색팀명 - 목록의 팀명 컬럼(List.js)과 동일하게 사업장 메타 team_company_list[].com_name 기준으로 검색
      if (search.company_name && search.team_name) {
        conditions.push({key: 'field.team_company_list[%].com_name', operator: '=', value: search.team_name})
      }
      return conditions;
    },

    async loadListBoard() {
      // TableListPage.initSearchConditions 와 동일하게, "field." 로 시작하는 키(사업장 메타 검색)는
      // conditions 가 아닌 fieldConditions 로 분리해서 보내야 API 에서 검색된다.
      const fieldConditions = [];
      const conditions = this.getConditions(this.nav).filter((condition) => {
        if (condition.key && condition.key.indexOf("field.") === 0) {
          fieldConditions.push({ ...condition, key: condition.key.replace("field.", "") });
          return false;
        }
        return true;
      });
      const options = {
        projectId: this.projectId,
        boardId: this.boardId,
        page: this.page,
        perPage: this.perPage,
        conditions,
        fieldConditions,

        orderDirection: "desc",
      };

      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);

      const _datas = response.data.map((data) => {
        const content = JSON.parse(data.post_content);
        console.log("content", content);
        return {
          year: content.header.year,
          부서명_과: content.body.stdInfo.부서명_과,
          targetInfo: content.body.targetInfo,
          symptomTable: content.body.symptomTable,
        };
      });
      console.log("_datas", _datas);

      this.list = _datas;
      this.성별데이터 = this.chartItemData("성별", "targetInfo.gender");
      this.결혼데이터 = this.chartItemData("결혼여부", "targetInfo.marriage");
      this.기본정보데이터 = this.basicInfoList();
      this.여가및취미활동데이터 = this.chartItemArrayData("여가및취미활동", "symptomTable.input1");
      this.하루평균가사노동시간데이터 = this.chartItemData("하루평균가사노동시간", "symptomTable.input2");
      this.질병진단여부데이터 = this.chartItemData("질병진단여부", "symptomTable.input3");
      this.질병_현재상태데이터 = this.chartItemData("질병_현재상태", "symptomTable.input3_option1", "symptomTable.input3");
      this.질병_질병명데이터 = this.chartItemArrayData("질병_질병명", "symptomTable.input3_option2", "symptomTable.input3");
      this.사고여부데이터 = this.chartItemData("사고여부", "symptomTable.input4");
      this.사고_부위데이터 = this.chartItemArrayData("사고_부위", "symptomTable.input4_option", "symptomTable.input4");
      this.육체적부담정도데이터 = this.chartItemData("육체적부담정도", "symptomTable.input5");
      this.근골증상여부데이터 = this.chartItemData("근골증상여부", "symptomTable.input6");
      this.근골증상_통증지속시간데이터 = this.chartSymptomPainDuration("근골증상_통증지속시간", 1);
      this.근골증상_통증정도데이터 = this.chartSymptomPainDuration("근골증상_통증정도", 2);
      this.근골증상_통증빈도데이터 = this.chartSymptomPainDuration("근골증상_통증빈도", 3);
      this.근골증상_지난1주일증상여부데이터 = this.chartSymptomPainDuration("근골증상_지난1주일증상여부", 4);
      this.근골증상_통증으로인해일어난일데이터 = this.chartSymptomTreatmentMethod("근골증상_통증으로인해일어난일");
      this.근골증상_근골격계질환자추정데이터 = this.chartSymptomEstimation("근골증상_근골격계질환자추정", "symptomTable.input6_option2_result");
    },

    basicInfoList() {
      // 유효한 데이터만 필터링하는 함수
      const filterValidData = (list, key) => {
        return list.filter((item) => item && item.targetInfo && item.targetInfo[key] !== undefined && item.targetInfo[key] !== "").map((item) => parseFloat(item.targetInfo[key]) || 0);
      };

      // 각 항목별 평균 계산
      const ageData = filterValidData(this.list, "age");
      const ageAvg = ageData.length ? ageData.reduce((sum, val) => sum + val, 0) / ageData.length : 0;

      // 현직장경력 (월 단위로 변환: 년*12 + 월)
      const workExpAvg =
        this.list.reduce((sum, item) => {
          if (!item || !item.targetInfo) return sum;

          const years = parseFloat(item.targetInfo.workExperience1) || 0;
          const months = parseFloat(item.targetInfo.workExperience2) || 0;

          return sum + years * 12 + months; // 월 단위로 변환
        }, 0) / this.list.filter((item) => item && item.targetInfo).length || 0;

      // 현재작업기간 (월 단위로 변환: 년*12 + 월)
      const workPeriodAvg =
        this.list.reduce((sum, item) => {
          if (!item || !item.targetInfo) return sum;

          const years = parseFloat(item.targetInfo.currentPeriod1) || 0;
          const months = parseFloat(item.targetInfo.currentPeriod2) || 0;

          return sum + years * 12 + months; // 월 단위로 변환
        }, 0) / this.list.filter((item) => item && item.targetInfo).length || 0;

      const workTimeData = filterValidData(this.list, "dayWorkTime");
      const workTimeAvg = workTimeData.length ? workTimeData.reduce((sum, val) => sum + val, 0) / workTimeData.length : 0;

      // 휴식시간 (dayRestTime1 * dayRestTime2) - 결과값이 분 단위
      const restTimeAvg =
        this.list.reduce((sum, item) => {
          if (!item || !item.targetInfo) return sum;

          const time1 = parseFloat(item.targetInfo.dayRestTime1) || 0;
          const time2 = parseFloat(item.targetInfo.dayRestTime2) || 0;

          return sum + time1 * time2;
        }, 0) / this.list.filter((item) => item && item.targetInfo).length || 0;

      // 결과 객체 반환 - 각 단위에 맞게 변경
      return [
        { 구분: "나이(세)", 평균: parseFloat(ageAvg.toFixed(1)) },
        {
          구분: "현직장경력(월)",
          평균: `${parseFloat(workExpAvg.toFixed(1))} (${Math.floor(workExpAvg / 12)}년 ${String(Math.floor(workExpAvg % 12)).padStart(2, "0")}개월)`,
        },
        {
          구분: "현재 작업기간(월)",
          평균: `${parseFloat(workPeriodAvg.toFixed(1))} (${Math.floor(workPeriodAvg / 12)}년 ${String(Math.floor(workPeriodAvg % 12)).padStart(2, "0")}개월)`,
        },
        { 구분: "1일 근무시간", 평균: parseFloat(workTimeAvg.toFixed(1)) },
        { 구분: "휴식시간(분)", 평균: parseFloat(restTimeAvg.toFixed(1)) },
      ];
    },

    chartItemArrayData(category, itemLabel, option) {
      // 카테고리에 따른 결과 유형 정의
      const resultType = this.getChartResultType(category);

      // itemLabel을 점을 기준으로 분리
      const pathParts = itemLabel.split(".");

      // option이 존재하는 경우 경로 분리
      let optionPathParts = [];
      if (option) {
        optionPathParts = option.split(".");
      }

      // 여가 활동 유형별 인원 카운트
      const activitiesCount = this.list.reduce((acc, item) => {
        if (!item) return acc;

        // option이 존재하는 경우 해당 옵션이 '예'인지 확인
        if (option) {
          let optionValue = item;
          for (const part of optionPathParts) {
            if (optionValue === undefined || optionValue === null) return acc;
            optionValue = optionValue[part];
          }

          // option 값이 '예'가 아닌 경우 건너뜀
          if (optionValue !== "예") return acc;
        }

        // 중첩된 속성에 안전하게 접근
        let value = item;
        for (const part of pathParts) {
          if (value === undefined || value === null) return acc;
          value = value[part];
        }

        // value가 배열인지 확인
        const activities = Array.isArray(value) ? value : [];

        activities.forEach((activity) => {
          if (activity) {
            acc[activity] = (acc[activity] || 0) + 1;
          }
        });

        return acc;
      }, {});

      // 총 선택된 활동 개수 계산 (중복 선택 포함)
      const totalActivities = Object.values(activitiesCount).reduce((sum, count) => sum + count, 0);
      this.chart인원(category, totalActivities);

      const result = resultType.map((activity) => ({
        구분: activity,
        인원: activitiesCount[activity] || 0,
        점유율: totalActivities ? parseFloat((((activitiesCount[activity] || 0) / totalActivities) * 100).toFixed(1)) : 0,
      }));

      return result;
    },

    chartItemData(category, itemLabel, option) {
      // 카테고리에 따른 결과 유형 정의
      const resultType = this.getChartResultType(category);

      // itemLabel을 점을 기준으로 분리 (예: 'symptomTable.input2' -> ['symptomTable', 'input2'])
      const pathParts = itemLabel.split(".");

      // option이 존재하는 경우 경로 분리
      let optionPathParts = [];
      if (option) {
        optionPathParts = option.split(".");
      }

      // 유효하고 정의된 카테고리에 맞는 응답만 필터링
      const validResponses = this.list.filter((item) => {
        if (!item) return false;

        // 중첩된 속성에 안전하게 접근
        let value = item;
        for (const part of pathParts) {
          if (value === undefined || value === null) return false;
          value = value[part];
        }

        // 값이 존재하고 resultType에 포함되어 있는지 확인
        if (!value || !resultType.includes(value)) return false;

        // option이 존재하는 경우 해당 옵션이 '예'인지 확인
        if (option) {
          let optionValue = item;
          for (const part of optionPathParts) {
            if (optionValue === undefined || optionValue === null) return false;
            optionValue = optionValue[part];
          }

          // option 값이 '예'인 경우만 포함
          return optionValue === "예";
        }

        return true;
      });

      // 인원 카운트 (위와 같은 방식으로 중첩 속성에 접근)
      const checkCount = validResponses.reduce((acc, item) => {
        let value = item;
        for (const part of pathParts) {
          value = value[part];
        }

        acc[value] = (acc[value] || 0) + 1;
        return acc;
      }, {});

      // 전체 인원 수 계산 (유효한 응답만)
      const totalCount = validResponses.length;
      this.chart인원(category, totalCount);

      // 이하 코드는 동일...
      let sumPercentage = 0;
      let totalCalculated = 0;

      const result = resultType.map((activity) => {
        const count = checkCount[activity] || 0;
        totalCalculated += count;

        // 소수점 1자리까지 계산
        const percentage = totalCount > 0 ? Math.round((count / totalCount) * 100 * 10) / 10 : 0;

        sumPercentage += percentage;

        return {
          구분: activity,
          인원: count,
          점유율: percentage,
        };
      });

      // 반올림 오차 보정
      if (result.length > 0 && Math.abs(sumPercentage - 100) < 0.5) {
        const lastItem = result[result.length - 1];
        lastItem.점유율 = Math.round((lastItem.점유율 + (100 - sumPercentage)) * 10) / 10;
      }

      return result;
    },

    chartSymptomPainDuration(category, index) {
      // 근골증상 구분 항목들 가져오기
      const bodyParts = this.getChartResultType("근골증상_구분"); // ['목', '어깨', '팔/팔꿈치', '손/손가락/손목', '허리', '다리/발']
      const durationTypes = this.getChartResultType(category);

      // 결과 데이터 초기화 - 구분(신체 부위)별로 객체 생성
      const result = bodyParts.map((part) => {
        // 각 지속 기간별 수량을 저장할 객체
        const durations = {};
        durationTypes.forEach((duration) => {
          durations[duration] = 0;
        });

        return {
          구분: part,
          ...durations,
          합계: 0,
        };
      });

      // 응답자 데이터 분석
      this.list.forEach((item) => {
        // 유효성 검사: symptomTable 있고 input6이 '예'인 경우만 처리
        if (!item || !item.symptomTable || item.symptomTable.input6 !== "예") return;

        // input6_option1에 선택된 부위 목록 확인
        const selectedParts = Array.isArray(item.symptomTable.input6_option1) ? item.symptomTable.input6_option1 : [];

        if (!selectedParts.length || !item.symptomTable.input6_option2) return;

        // 선택된 각 부위별로 통증 지속 기간 확인
        selectedParts.forEach((part) => {
          const partIndex = bodyParts.indexOf(part);
          if (partIndex === -1) return; // 매칭되는 부위가 없으면 건너뛰기

          // 해당 부위의 통증 데이터 배열
          const painData = item.symptomTable.input6_option2[part];
          if (!Array.isArray(painData) || painData.length <= index) return;

          // 지정된 인덱스의 정보 추출
          const infoData = painData[index];
          if (!infoData) return; // 정보가 없으면 건너뛰기

          // '부위-N|정보' 형식에서 정보 추출
          const infoMatch = infoData.match(new RegExp(`-${index}\\|(.*)`));
          if (!infoMatch) return;

          const duration = infoMatch[1]; // | 이후의 값(지속 기간)

          // 해당 부위와 지속 기간에 대한 카운트 증가
          if (result[partIndex][duration] !== undefined) {
            result[partIndex][duration]++;
            result[partIndex].합계++;
          }
        });
      });
      return result;
    },

    chartSymptomTreatmentMethod(category) {
      // 근골증상 구분 항목들 가져오기
      const bodyParts = this.getChartResultType("근골증상_구분");
      const treatmentTypes = this.getChartResultType(category);

      // 결과 데이터 초기화 - 구분(신체 부위)별로 객체 생성
      const result = bodyParts.map((part) => {
        // 각 처치 방법별 수량을 저장할 객체
        const treatments = {};
        treatmentTypes.forEach((treatment) => {
          treatments[treatment] = 0;
        });

        return {
          구분: part,
          ...treatments,
          합계: 0,
        };
      });

      // 응답자 데이터 분석
      this.list.forEach((item) => {
        // 유효성 검사: symptomTable 있고 input6이 '예'인 경우만 처리
        if (!item || !item.symptomTable || item.symptomTable.input6 !== "예") return;

        // input6_option1에 선택된 부위 목록 확인
        const selectedParts = Array.isArray(item.symptomTable.input6_option1) ? item.symptomTable.input6_option1 : [];

        if (!selectedParts.length || !item.symptomTable.input6_option2) return;

        // 선택된 각 부위별로 통증 처치 방법 확인
        selectedParts.forEach((part) => {
          const partIndex = bodyParts.indexOf(part);
          if (partIndex === -1) return; // 매칭되는 부위가 없으면 건너뛰기

          // 해당 부위의 통증 데이터 배열
          const painData = item.symptomTable.input6_option2[part];
          if (!Array.isArray(painData) || painData.length <= 5) return;

          // 5번 인덱스의 정보(통증으로 인해 일어난 일) 추출
          const treatmentData = painData[5];
          if (!treatmentData) return;

          // 배열인 경우 각 항목 처리
          if (Array.isArray(treatmentData)) {
            treatmentData.forEach(treatment => {
              if (result[partIndex][treatment] !== undefined) {
                result[partIndex][treatment]++;
                result[partIndex].합계++;
              }
            });
          }
          // 문자열인 경우 처리
          else if (typeof treatmentData === 'string') {
            // '부위-5|[항목1,항목2]' 형식일 수 있음
            try {
              const match = treatmentData.match(/-5\|(.*)/);
              if (match) {
                const treatmentStr = match[1];
                let treatments;

                // JSON 형태로 파싱 시도
                try {
                  treatments = JSON.parse(treatmentStr);
                } catch (e) {
                  // 파싱 실패시 문자열 그대로 사용
                  treatments = [treatmentStr];
                }

                if (Array.isArray(treatments)) {
                  treatments.forEach(treatment => {
                    if (result[partIndex][treatment] !== undefined) {
                      result[partIndex][treatment]++;
                      result[partIndex].합계++;
                    }
                  });
                }
              }
            } catch (e) {
              console.error('Treatment data parsing error:', e);
            }
          }
        });
      });

      return result;
    },

    chartSymptomEstimation(category, itemLabel) {
      // 카테고리에 따른 결과 유형 정의
      const resultType = this.getChartResultType(category);

      // itemLabel을 점을 기준으로 분리
      const pathParts = itemLabel.split(".");

      // 각 결과 유형별 카운트를 저장할 객체 초기화
      const countByType = {};
      resultType.forEach(type => {
        countByType[type] = 0;
      });

      // 응답자 데이터 분석
      this.list.forEach(item => {
        // 중첩 속성 접근
        let value = item;
        for (const part of pathParts) {
          if (!value || value[part] === undefined) {
            value = null;
            break;
          }
          value = value[part];
        }

        if (!value || !Array.isArray(value)) return;

        // 우선순위에 따라 카운팅 (통증호소자 > 관리대상자 > 정상)
        if (value.includes('통증호소자')) {
          countByType['통증호소자']++;
        } else if (value.includes('관리대상자')) {
          countByType['관리대상자']++;
        } else if (value.includes('정상')) {
          countByType['정상']++;
        }
      });

      // 총 인원 수 계산
      const totalCount = Object.values(countByType).reduce((sum, count) => sum + count, 0);
      this.chart인원(category, totalCount);

      // 각 유형별 점유율 계산 및 결과 생성
      const result = resultType.map((type, index) => {
        const count = countByType[type];
        const percentage = totalCount > 0 ? Math.round((count / totalCount) * 100) : 0;

        return {
          순번: index + 1,
          구분: type,
          인원: count,
          점유율: percentage
        };
      });

      return result;
    },

    prepareSymptomPainDurationChart(category = "근골증상_통증지속시간") {
      const dataMap = {
        "근골증상_통증지속시간": this.근골증상_통증지속시간데이터,
        "근골증상_통증정도": this.근골증상_통증정도데이터,
        "근골증상_통증빈도": this.근골증상_통증빈도데이터,
        "근골증상_지난1주일증상여부": this.근골증상_지난1주일증상여부데이터,
        "근골증상_통증으로인해일어난일": this.근골증상_통증으로인해일어난일데이터,
      };

      const data = dataMap[category];
      if (!data || !data.length) return { series: [], categories: [] };

      const typeList = this.getChartResultType(category);
      const series = [];

      // 각 통증 지속 기간 또는 통증 정도별로 시리즈 생성
      typeList.forEach((type) => {
        const seriesData = data.map(item => item[type] || 0);

        series.push({
          name: type,
          data: seriesData
        });
      });

      // 카테고리(신체 부위) 데이터 추출
      const categories = data.map(item => item.구분);

      return {
        series,
        categories
      };
    },

    getChartResultType(category) {
      switch (category) {
        case "성별":
          return ["남", "여"];
        case "결혼여부":
          return ["기혼", "미혼"];
        case "여가및취미활동":
          return ["게임 등 컴퓨터 관련 활동", "아노, 드럼펫 등 악기연주", "뜨개질, 붓글씨 등", "테니스, 축구, 농구, 골프 등 스포츠 활동", "해당사항 없음"];
        case "하루평균가사노동시간":
          return ["거의 하지 않는다", "1시간 미만", "1-2시간 미만", "2-3시간 미만", "3시간 이상"];
        case "질병진단여부":
          return ["예", "아니오"];
        case "질병_현재상태":
          return ["완치", "치료나 관찰중"];
        case "질병_질병명":
          return ["류머티스 관절염", "당뇨병", "통풍", "알코올중독", "해당사항 없음"];
        case "사고여부":
          return ["예", "아니오"];
        case "사고_부위":
          return ["손/손가락/손목", "팔/팔꿈치", "어깨", "목", "허리", "다리/발"];
        case "육체적부담정도":
          return ["전혀 힘들지 않음", "견딜만 함", "약간 힘듦", "힘듦", "매우 힘듦"];
        case "근골증상여부":
          return ["예", "아니오"];
        case "근골증상_구분":
          return ["목", "어깨", "팔/팔꿈치", "손/손가락/손목", "허리", "다리/발"];
        case "근골증상_통증지속시간":
          return ["1일 미만", "1일 - 1주일 미만", "1주일 - 1달 미만", "1달 - 6개월 미만", "6개월 이상"];
        case "근골증상_통증정도":
          return ["약한 통증", "중간 통증", "심한 통증", "매우 심한 통증"];
        case "근골증상_통증빈도":
          return ["6개월에 1번", "2-3달에 1번", "1달에 1번", "1주일에 1번", "매일"];
        case "근골증상_지난1주일증상여부":
          return ["아니오", "예"];
        case "근골증상_통증으로인해일어난일":
          return ["병원, 한의원 치료", "약국치료", "병가, 산재", "작업 전환", "해당사항 없음"];
        case "근골증상_근골격계질환자추정":
          return ["정상", "관리대상자", "통증호소자"];
        default:
          return [];
      }
    },

    chart인원(category, total) {
      switch (category) {
        case "성별":
          this.성별인원 = total;
          break;
        case "결혼여부":
          this.결혼인원 = total;
          break;
        case "여가및취미활동":
          this.여가및취미활동인원 = total;
          break;
        case "하루평균가사노동시간":
          this.하루평균가사노동시간인원 = total;
          break;
        case "질병진단여부":
          this.질병진단여부인원 = total;
          break;
        case "질병_현재상태":
          this.질병_현재상태인원 = total;
          break;
        case "질병_질병명":
          this.질병_질병명인원 = total;
          break;
        case "사고여부":
          this.사고여부인원 = total;
          break;
        case "사고_부위":
          this.사고_부위인원 = total;
          break;
        case "육체적부담정도":
          this.육체적부담정도인원 = total;
          break;
        case "근골증상여부":
          this.근골증상여부인원 = total;
          break;
        case "근골증상_근골격계질환자추정":
          this.근골증상_근골격계질환자추정인원 = total;
          break;

        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
h5 {
  font-size: 16px;
  font-weight: 500;
  color: #3c3c3c;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    padding: 10px 7px;
  }

  th,
  tr.avg td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    background: #f9f9f9;
  }
  td {
    font-size: 14px;
    font-weight: 400;
    text-align: center;

    background: white;
  }
}

.card-grid {
  grid-template-columns: 1fr 1fr 1fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.responsive-grid {
  grid-template-columns: 1.8fr 1.2fr;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}
</style>
